import { render, staticRenderFns } from "./DataUpgradeInsertDialog.vue?vue&type=template&id=dcdb129e&scoped=true&"
import script from "./DataUpgradeInsertDialog.vue?vue&type=script&lang=js&"
export * from "./DataUpgradeInsertDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdb129e",
  null
  
)

export default component.exports